import produce from 'immer';
import QuizService from '../../services/quizService';
import { QUIZ_START, QUIZ_ANSWER, QUIZ_ERROR, QUIZ_NEXT, QUIZ_END, QUIZ_RESTART, QUIZ_DIPLOMA } from './actions';
import { LOGIN_LOGOUT } from '../auth/actions';

const initialState = {
  startTime: null,
  endTime: null,
  finishTime: null,
  questionsForClass: [],
  questionsForStudent: [],
  questions: [],
  question: null,
  questionIndex: null,
  validAnswers: 0,
  error: '',
  percentage: null,
  diplomaDownloaded: false,
};

export default function quizReducer(state = initialState, action) {
  switch (action.type) {
    case QUIZ_START:
      return produce(state, draft => {
        draft.startTime = action.payload.startTime;
        draft.endTime = action.payload.endTime;
        draft.questionsForClass = action.payload.questionsForClass;
        draft.questionsForStudent = action.payload.questionsForStudent;
        draft.questions = draft.questionsForStudent; // At first student is going to get all of them
        draft.questionIndex = 0;
        draft.question = draft.questions[0];
        draft.error = '';
      });
      break;
    case QUIZ_ANSWER:
      return produce(state, draft => {
        const question = draft.question;
        const answer = action.payload.answer;
        const questionIndex = draft.questions.findIndex(q => q.id === question.id);

        switch (question.type) {
          case 'single':
          case 'true-or-false':
            question.checked = [answer];
            draft.error = '';
            draft.questions[questionIndex] = question;
            break;
          default:
            break;
        }
      });
      break;
    case QUIZ_ERROR:
      return produce(state, draft => {
        draft.error = action.payload.error;
      });
      break;
    case QUIZ_NEXT:
      return produce(state, draft => {
        draft.questionIndex = action.payload.questionIndex;
        draft.question = action.payload.question;
        draft.error = '';
      });
      break;
    case QUIZ_END:
      return produce(state, draft => {
        draft.finishTime = action.payload.finishTime;
        draft.questionsForStudent = action.payload.questionsForStudent;
        draft.validAnswers = action.payload.validAnswers;
        draft.percentage = action.payload.percentage;
        draft.error = '';
      });
      break;
    case QUIZ_RESTART:
      return produce(state, draft => {
        draft.startTime = action.payload.startTime;
        draft.endTime = action.payload.endTime;
        draft.questions = action.payload.questions.map(question => {
          return {
            ...question,
            checked: [],
          };
        });
        draft.questionIndex = 0;
        draft.question = draft.questions[0];
        draft.validAnswers = 0;
        draft.percentage = null;
        draft.error = '';
      });
      break;
    case QUIZ_DIPLOMA:
      return produce(state, draft => {
        draft.diplomaDownloaded = true;
      });
      break;
    case LOGIN_LOGOUT:
      return Object.assign({}, initialState);
      break;
    default:
      return state;
  }
}
